import React from "react";
import PropTypes from "prop-types";
import {Edit, SimpleForm} from "react-admin";
import EditActions from "./EditActions";
import {EditFormActions} from "./FormActions";

EditView.propTypes = {
  noDel: PropTypes.bool,
};

function EditView(props) {
  const {noDel = false} = props;
  return (
    <Edit mutationMode="pessimistic" {...props}  undoable={false} actions={<EditActions noDel={noDel}/>}>
      <SimpleForm submitOnEnter={false} variant="outlined" toolbar={<EditFormActions/>}>{props.children}</SimpleForm>
    </Edit>
  );
}

export default EditView;
